// extracted by mini-css-extract-plugin
module.exports = {"info-text":"rotateBarcodePostAction_info-text__7AQyy","checkbox-and-tooltip":"rotateBarcodePostAction_checkbox-and-tooltip__1yFky"};